import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { VesselAssignmentWithRelations } from "./useVesselAssignments";

/**
 * Returns all active assignments with no vessel — i.e. lots that need placing.
 * These appear in the On Deck sidebar. vessel_id IS NULL means unplaced.
 * Joins both wine_lot (real lots) and planning_lot (tentative lots).
 */
export function useOnDeckAssignments({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["on-deck-assignments"],
    enabled,
    staleTime: 0,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("vessel_assignment")
        .select(`
          *,
          wine_lot:wine_lot_id (
            id,
            code,
            varietal,
            vintage,
            current_volume_l,
            client!wine_lot_client_id_fkey (
              id,
              name
            )
          ),
          planning_lot:planning_lot_id (
            id,
            code,
            varietal,
            vintage,
            current_volume_l,
            is_received,
            wine_lot_id,
            client:client_id (
              id,
              name
            )
          )
        `)
        .is("vessel_id", null)
        .in("status", ["planned", "active"])
        .order("updated_at", { ascending: false });

      if (error) throw error;
      return (data || []) as VesselAssignmentWithRelations[];
    },
  });
}
